export const MODAL = {
    PROFILE_SETTING: 'PROFILE_SETTING',
    DESIGN_SETTING: 'DESIGN_SETTING',
    PUBLISH: 'PUBLISH',
    LOGIN: 'LOGIN',
    /** BLOCK **/
    BLOCK_SETTING: 'BLOCK_SETTING',
    ADD_BLOCK: 'ADD_BLOCK',
    /** DESIGN **/
    BACKGROUND_SETTING: 'BACKGROUND_SETTING',
    COLOR_SETTING: 'COLOR_SETTING',
    CHOOSE_COLOR: 'CHOOSE_COLOR',
    FONT: 'FONT',
    CHOOSE_FONT: 'CHOOSE_FONT',
    CHOOSE_THEME: 'CHOOSE_THEME',
    STYLE_SETTING: 'STYLE_SETTING',
    /** PROFILE **/
    BASIC_INFO_SETTING: 'BASIC_INFO_SETTING',
    CONTACT_SETTING: 'CONTACT_SETTING',
    OPENING_HOURS_SETTING: 'OPENING_HOURS_SETTING',
    UPDATE_OPENING_HOURS: 'EDIT_OPENING_HOURS',
    /** LINKS **/
    CUSTOM_LINK_SETTING: 'CUSTOM_LINK_SETTING',
    UPDATE_CUSTOM_LINK_SETTING: 'UPDATE_CUSTOM_LINK_SETTING',
    ORDER_LINK_SETTING: 'ORDER_LINK_SETTING',
    UPDATE_ORDER_LINK_SETTING: 'UPDATE_ORDER_LINK_SETTING',
    SOCIAL_LINK_SETTING: 'SOCIAL_LINK_SETTING',
    UPDATE_SOCIAL_LINK_SETTING: 'UPDATE_SOCIAL_LINK_SETTING',
    UPGRADE_ACCOUNT: 'UPGRADE_ACCOUNT',
    UPGRADE_ACCOUNT_SUCCESS: 'UPGRADE_ACCOUNT_SUCCESS',
};

export const BLOCKS_MODE = {
    EDIT: 'EDIT',
};
